module.exports = __webpack_public_path__ + "img/Group3184.a45d77af.png";